import React, { useContext, useEffect, useState } from "react";
import FadeIn from "react-fade-in";
import supportConnect from "../../../assets/images/actions/support_connect.png";
import notifySupport from "../../../assets/images/actions/notify_support_person.png";
import exercise from "../../../assets/images/actions/exercise.png";
import mindfulness from "../../../assets/images/actions/mindfulness.png";
import virtualCommute from "../../../assets/images/actions/virtual_commute.png";
import eatWell from "../../../assets/images/actions/eat_well.png";
import { generateURLOptions } from "../../../URLOptions";
import { GET_PAGE_TITLE, SUBMIT_SUPPORT_REQUEST } from "../../../Routes";
import axios from "axios";
import { UserContext } from "../../../storage/contexts/UserContext";
import CommonWellnessItem from "../../../InterstellrComponents/CommonWellnessItem";
import NotifySupportPersonModal from "../../../InterstellrModals/NotifySupportPersonModal";

const EmployeeWellness = () => {
  const { profile } = useContext(UserContext);
  const [pageTitle, setPageTitle] = useState("");

  const [showNotify, setShowNotify] = useState(false);

  const actions = [
    {
      id: "eat-well",
      name: "Eat Well",
      image: eatWell,
      route: "/wellness/recipes",
    },
    {
      id: "exercise",
      name: "Exercise",
      image: exercise,
      route: "/wellness/exercises",
    },
    {
      id: "mindfulness",
      name: "Mindfulness",
      image: mindfulness,
      route: "/wellness/mindfulness",
    },
    {
      id: "virtual-commute",
      name: "Virtual Commute",
      image: virtualCommute,
      route: "/wellness/commute",
    },
    {
      id: "support-connect",
      name: "Support Connect",
      image: supportConnect,
      route: "/wellness/support",
    },
    {
      id: "notify-support",
      name: "Notify Support Person",
      image: notifySupport,
      action: () => setShowNotify(true),
    },
  ];

  useEffect(() => {
    getPageTitle();
  }, []);

  const getPageTitle = async () => {
    await axios
      .get(GET_PAGE_TITLE + "wellness", {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        setPageTitle(response.data?.heading ?? "");
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  const submitSupportRequest = async (managerId) => {
    await axios
      .post(
        SUBMIT_SUPPORT_REQUEST,
        {
          managerId,
        },
        {
          headers: generateURLOptions(),
        }
      )
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  return (
    <>
      <NotifySupportPersonModal
        isOpen={showNotify}
        onClose={() => setShowNotify(false)}
        onSubmit={(person) => {
          setShowNotify(false);
          submitSupportRequest(person?._id);
        }}
      />
      <div className="relative">
        <div
          className="z-0 h-[90vh] absolute top-0 bottom-0 left-0 right-0"
          style={{
            background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
              profile?.company_id
                ? profile?.company_id?.company_primary_color
                : "rgba(81, 83, 245, 1)"
            } 150%)`,
          }}
        />
        <div className="z-10 relative container mx-auto flex flex-col justify-center items-center h-full w-full">
          <div className="w-full px-6 md:px-0 md:w-2/3 pt-10 md:pt-24">
            <FadeIn delay={200}>
              {/* Page Title */}
              <h4 className="text-2xl font-semibold">
                {pageTitle ? pageTitle : "Take Control of Your Wellbeing"}
              </h4>

              <FadeIn delay={450}>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4 mt-4">
                  {actions?.map((action) => (
                    <CommonWellnessItem key={action?.id} item={action} />
                  ))}
                </div>
              </FadeIn>
            </FadeIn>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeWellness;
